import React from 'react';
import { Link } from 'found';
import { Box, Theme, Typography, useMediaQuery } from '@mui/material';
import { palette, spaces } from '../../assets/styles/themes/tokens';
import { IconName } from '../../utils/getMuiIcon';
import getTextTruncationSx from '../../utils/getTextTruncationSx';
import { renderToolbarIcon } from '../../utils/renderToolbarIcon';

type BreadcrumbsProps = {
  links: {
    title?: string;
    url?: string;
    iconName?: IconName;
    iconViewbox?: string;
  }[];
};

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ links }) => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('mobile'));
  const Separator = () => 
    <Typography 
      variant='body1' 
      sx={{ width: 7, height: 24 }} 
      data-testid='breadcrumbs-separator'>/</Typography>;

  return (
    <Box data-testid='breadcrumbs' sx={{ display: 'flex', alignItems: 'center', height: 24, gap: spaces.xs }}>
      {
        links.map(({ url, title, iconName, iconViewbox }, index) => {
          const isLast = index === links.length - 1;
          const color = isLast ? palette.text.primary :  palette.primary.main;

          return (
            <React.Fragment key={index}>
              {iconName && (
                url ? (
                  <Link to={url} aria-label={title}>
                    {renderToolbarIcon(iconName, color, true, iconViewbox)}
                  </Link>
                ) : (
                  renderToolbarIcon(iconName, color, true, iconViewbox)
                )
              )}
              {
                isMobile && !isLast ? null : url ?
                  <Link to={url}>
                    <Typography sx={{ color, whiteSpace: 'nowrap' }} variant='body2'>{title}</Typography>
                  </Link>
                  : <Typography sx={{ color, ...getTextTruncationSx() }} variant='body2'>{title}</Typography>
              }
              { !isLast && <Separator /> }
            </React.Fragment>
          );
        })
      }
    </Box>
  );
};

export default Breadcrumbs;
